import "./boxSizing.js";
import "./swiper.js";
import "./animations.js";
import "./forms.js";
import "./fancybox.js";
import "./socials.js";
import "./leaflet.js";

import Alpine from "alpinejs";
import Lenis from "lenis";
import imagesLoaded from "imagesloaded";
import Masonry from "masonry-layout";

window.Alpine = Alpine;
Alpine.start();

// Smooth scrolling
const lenis = new Lenis({
  lerp: 0.2,
  wheelMultiplier: 0.8,
  infinite: false,
  gestureOrientation: "vertical",
  normalizeWheel: false,
  syncTouch: false,
  autoRaf: true,
});

// Masonry
window.initMasonry = function () {
  const grid = document.querySelector("#masonry-grid");
  if (!grid) return; // exit if not found

  imagesLoaded(grid, () => {
    setTimeout(() => {
      new Masonry(grid, {
        itemSelector: ".masonry-item",
        percentPosition: true,
        gutter: 24,
      });
    }, 10);
  });
};
window.initMasonry();

// height fix case-blog page
document.addEventListener("DOMContentLoaded", () => {
  const fullImg = document.querySelector(".case-img");
  const sideImgs = document.querySelectorAll(".case-images img");

  const updateSideImageHeights = () => {
    if (window.innerWidth > 768) {
      if (!fullImg || !sideImgs.length) return;

      const fullHeight = fullImg.clientHeight;
      let visibleCount = 3; // default for desktop

      if (window.matchMedia("(max-width: 1023px)").matches) {
        visibleCount = 2; // for screens under 1024px
      }

      const galleryContainer = document.querySelector(".case-images");
      if (galleryContainer) {
        galleryContainer.style.maxHeight = `${fullHeight}px`;
      }

      const imgHeight = fullHeight / visibleCount;
      sideImgs.forEach((img) => {
        img.style.height = `${imgHeight - 16}px`;
        img.style.objectFit = "cover";
      });
    }
  };

  updateSideImageHeights();
  window.addEventListener("resize", updateSideImageHeights);
});

/// Add lenis prevent on iubenda Iframe ////
// Wait for iubenda button to exist before attaching click listener
const waitForIubendaButton = setInterval(() => {
  const iubendaBtn = document.querySelector(
    ".iubenda-tp-btn.iubenda-cs-preferences-link"
  );
  if (iubendaBtn) {
    clearInterval(waitForIubendaButton);
    iubendaBtn.addEventListener("click", () => {
      const observer = new MutationObserver((mutations, obs) => {
        const iframeDiv = document.getElementById("iubenda-iframe");
        if (iframeDiv) {
          iframeDiv.setAttribute("data-lenis-prevent", "");
          obs.disconnect();
        }
      });

      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
    });
  }
}, 500);
